module.exports = __webpack_public_path__ + "img/collection-en-short.83d7548c.png";